import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const updateMeetupStatus = createAsyncThunk(
  "updateMeetupStatus",
  async ({ meetupId, status_sub_identifier }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.patch(`meetup/${meetupId}/status`, {
        status_sub_identifier,
      });
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const UpdateMeetupStatusSlice = createSlice({
  name: "UpdateMeetupStatusSlice",
  initialState: {
    isLoading: false,
    success: false,
    data: null,
    error: null,
  },
  reducers: {
    resetUpdateMeetupStatus: (state) => {
      state.isLoading = false;
      state.success = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateMeetupStatus.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateMeetupStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.data = action.payload?.data;
      })
      .addCase(updateMeetupStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateMeetupStatus } = UpdateMeetupStatusSlice.actions;
export default UpdateMeetupStatusSlice.reducer;
